import { SaveRequest, TemplateDetail } from '../models';

/**
 * Everything about the `designJson` field lives here, so switching the real
 * backend field on (or changing how it is stored) is a one-file change.
 */

export interface DesignReadResult {
    /** The server knows the designJson field (the key is present, even when null). */
    supported: boolean;
    /** Parsed Unlayer design to load, or null when the template is HTML-only. */
    design: object | null;
}

export function readDesign(detail: TemplateDetail): DesignReadResult {
    const custom = detail?.custom;
    const def = detail?.default;
    const supported = (!!custom && 'designJson' in custom) || (!!def && 'designJson' in def);
    if (!supported) {
        return { supported: false, design: null };
    }

    let json: string | null | undefined;
    if (custom) {
        json = custom.designJson;
        // A plain copy of the default has the same HTML, so the default's design still matches it.
        if (!json && def && custom.htmlBody === def.htmlBody) {
            json = def.designJson;
        }
    } else if (def) {
        json = def.designJson;
    }
    return { supported: true, design: parseDesign(json) };
}

export function writeDesign(request: SaveRequest, design: object, supported: boolean): SaveRequest {
    if (supported && design) {
        request.designJson = JSON.stringify(design);
    }
    return request;
}

function parseDesign(json: string | null | undefined): object | null {
    if (!json) {
        return null;
    }
    try {
        const design = JSON.parse(json);
        return design && typeof design === 'object' ? design : null;
    } catch {
        return null;
    }
}
